export default __webpack_public_path__ + "static/media/archieve-data.d55e08d5.svg";